function MessageIcon({
  className,
  color,
}: {
  className?: string;
  color?: string;
}): JSX.Element {
  return (
    <svg
      width="96"
      height="97"
      viewBox="0 0 99 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
    >
      <mask
        id="mask0_17146_9039"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="96"
        height="97"
      >
        <rect y="0.00170898" width="96" height="96" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_17146_9039)">
        <path
          d="M47.8769 43.6846L79.3539 23.0769H16.4769L47.8769 43.6846ZM47.8769 47.2231L15.0769 25.5231V69.8769C15.0769 70.5949 15.3077 71.1847 15.7692 71.6462C16.2307 72.1077 16.8205 72.3385 17.5384 72.3385H38.9846L42.0616 75.4154H17.5384C16.0013 75.4154 14.6939 74.8766 13.6163 73.7991C12.5388 72.7215 12 71.4141 12 69.8769V25.5384C12 24.0013 12.5388 22.6939 13.6163 21.6163C14.6939 20.5388 16.0013 20 17.5384 20H78.3154C79.8526 20 81.16 20.5388 82.2375 21.6163C83.3151 22.6939 83.8539 24.0013 83.8539 25.5384V48.4769L80.7769 51.5539V25.5231L47.8769 47.2231Z"
          fill="#004A68"
        />
      </g>
      <path
        d="M74.0313 87.1388L71.5021 84.5358L80.6683 75.3696H51.6006V71.7697H80.6683L71.5021 62.6035L74.0313 60.0005L87.6005 73.5697L74.0313 87.1388Z"
        fill="#004A68"
      />
    </svg>
  );
}

export default MessageIcon;
